import { Checkbox } from '@nimbus-ds/components';
import { PromotionTypes } from '@tiendanube/common/src/domains/marketing/promotions/PromotionTypes';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { PromotionFormProps } from '../PromotionForm';

type DiscountCombinationProps = Pick<PromotionFormProps, 'values' | 'onChange'>;

export function DiscountCombination({
  values: { combinesWithOtherDiscounts, promotionType },
  onChange,
}: Readonly<DiscountCombinationProps>) {
  const t = useTranslationMarketing(
    'promotions.settingsPage.applyTo.discountCombination',
  );

  const labelKey =
    promotionType === PromotionTypes.PERCENTAGE_OFF ? 'label%off' : 'label';

  return (
    <Checkbox
      name="combinesWithOtherDiscounts"
      label={t(labelKey)}
      onChange={onChange}
      checked={combinesWithOtherDiscounts}
    />
  );
}
